import { EnumListKey } from '~/data/enums';
import { EnumValue } from '~/data/proposals';
import { getFormattedEmploymentValue } from '~/scenes/PeopleModule/components/Tabs/BasicTab/components/EmploymentDataForm/data';
import { getEnumName } from '~/utils/helpers/enum';

export type EmploymentTranslateData = {
  fEmploymentStatusFK: string;
  fPersonnelGroup1FK: string;
  fPersonnelGroup2FK: string;
  fPersonnelGroup3FK: string;
  fPersonnelGroup4FK: string;
  fPersonnelGroup5FK: string;
  fStartDate: string;
  fEndDate: string;
  fInfo: string;
  fJobGradeFK: string;
  fTaxNumber: string;
  fVacBalCalcUseSixDays: string;
  fCalcHoursBalance: string;
};

export type ResolvedEmploymentData = {
  employmentStatus: string;
  personnelGroup1: string;
  personnelGroup2: string;
  personnelGroup3: string;
  personnelGroup4: string;
  personnelGroup5: string;
  startDate: string;
  endDate: string;
  info: string;
  jobGrade: string;
  taxNumber: string;
  vacationBalanceCalculation: string;
  calculateHoursBalance: boolean;
};

export type EnumMap = Partial<Record<EnumListKey, EnumValue[]>>;

export const resolveEmploymentTranslatedData = (
  translate: EmploymentTranslateData,
  personnelGroupEnums: EnumMap,
): ResolvedEmploymentData => ({
  employmentStatus: getFormattedEmploymentValue(
    translate.fEmploymentStatusFK,
    '_',
    '-',
  ),
  personnelGroup1: getEnumName(
    personnelGroupEnums[EnumListKey.PERSONNEL_GROUP_1] ?? [],
    translate.fPersonnelGroup1FK,
  ),
  personnelGroup2: getEnumName(
    personnelGroupEnums[EnumListKey.PERSONNEL_GROUP_2] ?? [],
    translate.fPersonnelGroup2FK,
  ),
  personnelGroup3: getEnumName(
    personnelGroupEnums[EnumListKey.PERSONNEL_GROUP_3] ?? [],
    translate.fPersonnelGroup3FK,
  ),
  personnelGroup4: getEnumName(
    personnelGroupEnums[EnumListKey.PERSONNEL_GROUP_4] ?? [],
    translate.fPersonnelGroup4FK,
  ),
  personnelGroup5: getEnumName(
    personnelGroupEnums[EnumListKey.PERSONNEL_GROUP_5] ?? [],
    translate.fPersonnelGroup5FK,
  ),
  startDate: translate.fStartDate,
  endDate: translate.fEndDate,
  info: translate.fInfo,
  jobGrade: getFormattedEmploymentValue(translate.fJobGradeFK, '_', ' '),
  taxNumber: translate.fTaxNumber,
  vacationBalanceCalculation: translate.fVacBalCalcUseSixDays,
  calculateHoursBalance: translate.fCalcHoursBalance === 'true',
});
